module.exports = __webpack_public_path__ + "static/media/bg-dontate.ecddc07b.png";